// extracted by mini-css-extract-plugin
module.exports = {"customBreadcrumb":"Breadcrumb_customBreadcrumb__1twEU"};